import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/redux/app/hooks';
import { setChatIcon, setLogo, setTheme } from 'shared/redux/features/theme/themeSlice';
import { lightTheme } from 'shared/styles';

const logoKey = 'logo';
const chatIconKey = 'chatLogo';

export const useTheme = () => {
    const dispatch = useAppDispatch();

    const { colors, images } = useAppSelector((state) => state.app.serviceInfo.settings);
    const { theme, chatIcon, logo } = useAppSelector((state) => state.theme);

    const updateTheme = (style: Record<string, string>) => {
        dispatch(setTheme(lightTheme(style)));
    };

    useEffect(() => {
        dispatch(setTheme(lightTheme(colors)));
    }, [dispatch, colors]);

    useEffect(() => {
        const chatIcon = images[chatIconKey];
        if (chatIcon) {
            dispatch(setChatIcon(chatIcon));
        }
    }, [dispatch, images]);

    useEffect(() => {
        const logo = images[logoKey];
        if (logo) {
            dispatch(setLogo(logo));
        }
    }, [dispatch, images]);

    return {
        theme,
        logo: logo ?? undefined,
        logoKey,
        chat: chatIcon ?? undefined,
        chatIconKey,
        updateTheme,
    };
};
